// Yerbaria: agrega productos sugeridos desde el carrito sin recargar la pagina.
// Si algo falla, recarga para que el carrito quede correcto.
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__ybUpsell) {
  window.__ybUpsell = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form || !form.hasAttribute('data-yb-upsell')) return;
    event.preventDefault();

    const button = form.querySelector('button');
    if (button) button.disabled = true;

    const id = Number(form.querySelector('[name="id"]').value);
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try {
      const addRes = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }],
          sections: 'cart-drawer-section',
          sections_url: window.location.pathname,
        }),
      });
      const added = await addRes.json();
      if (!addRes.ok || added.status) throw new Error(added.description || 'add failed');

      const cartRes = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      const cartJson = await cartRes.json();

      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'cart',
          lines: [{ id: String(id), quantity: 1 }],
          promise: deferred.promise,
        })
      );
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cartJson),
        detail: {
          sections: added.sections || undefined,
          items: cartJson.items,
          itemCount: cartJson.item_count,
          source: 'yb-upsell',
          didError: false,
        },
      });
    } catch (error) {
      console.warn('[yb-upsell]', error);
      window.location.reload();
    }
  });
}
